var map = {
	"./blog-01.jpg": 63373,
	"./blog-02.jpg": 94146,
	"./blog-03.jpg": 85855,
	"./blog-04.jpg": 7572,
	"./blog-05.jpg": 79377,
	"./blog-06.jpg": 63526,
	"./blog-07.jpg": 53635,
	"./latestpost-01.jpg": 76568,
	"./latestpost-02.jpg": 55495,
	"./latestpost-03.jpg": 16490,
	"./latestpost-04.jpg": 29081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76385;